"use client";

import { datadogRum } from "@datadog/browser-rum";
import { useEffect } from "react";
import { useSession } from "@/hooks/use-session";

export default function Datadog() {
  const { session } = useSession();

  useEffect(() => {
    if (session?.id) {
      datadogRum.setUser({
        id: session.id,
        name: session.name,
        email: session.email,
        ...(session.company ? { company: session.company } : {}),
      });
    } else {
      datadogRum.clearUser();
    }
  }, [session]);

  return null;
}
